import { FlowConfig } from '@/components/SimplifiedSignup/Context/types';

import TrueMedScreensConfig from './Screens';

const TrueMedOfferFlow: FlowConfig = {
	activeScreenKey: 'account',
	activeScreenConfig: TrueMedScreensConfig.account,
	name: 'TrueMedOffer',
	pageName: 'true-med-offer',
	screens: {
		account: TrueMedScreensConfig.account,
		payment: TrueMedScreensConfig.payment,
		handoff: TrueMedScreensConfig.handoff,
		error: TrueMedScreensConfig.error,
	},
	plan: 'yearly',
	hasFreeTrial: false,
	offerCountries: ['us'],
	offerCurrencies: ['USD'],
	shouldShowIneligibleOfferScreen: true,
};

export default TrueMedOfferFlow;
